// extracted by mini-css-extract-plugin
export default {"container":"Fileuploader_container__pnMVZ","fileitem":"Fileuploader_fileitem__XoVem","activated":"Fileuploader_activated__ui4XE"};